<template>
  <b-navbar toggleable="md" sticky variant="light" type="light" class="shadow-sm">
    <b-navbar-brand href="#" to="/">BOŠ Partneri</b-navbar-brand>

    <b-navbar-toggle target="colapse-nav"></b-navbar-toggle>
    <b-collapse is-nav id="colapse-nav">
      <b-navbar-nav>
        <b-nav-item :to="{name:'project'}">Projekat</b-nav-item>
        <b-nav-item :to="{name:'reports'}">Izveštaji</b-nav-item>
        <b-nav-item :to="{name:'resources'}">Resursi</b-nav-item>
        <b-nav-item :to="{name:'news'}">Vesti</b-nav-item>
        <b-nav-item :to="{name:'calendar'}">Kalendar</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto" right>
        <b-nav-item-dropdown :text="$store.getters['auth/userName']" right>
          <b-dropdown-item href="#" :to="{name:'profile'}">
            <i class="fas fa-user"></i>
            Moj nalog
          </b-dropdown-item>
          <b-dropdown-item href="#" :to="{name:'organization'}">
            <i class="fas fa-building"></i>
            Organizacija
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#" @click="logout">
            <i class="fas fa-sign-out-alt"></i>
            Logout
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  computed: {
    isLoggedIn: function() {
      return this.$store.getters["auth/isAuthenticated"];
    }
  },

  methods: {
    logout: function() {
      this.$store
        .dispatch("auth/logout")
        .then(() => {
          this.$router.push("/login");
        })
        .catch(err => {})
        .then(() => {
          this.$router.push("/login");
        });
    }
  }
};
</script>

<style>
</style>
